<script setup>
  import {ref, onMounted, watch, computed, getCurrentInstance, toRaw, onBeforeUnmount, inject, defineExpose} from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { usePageLoadingStore } from '../../../../../../stores/pageLoading'
  import { useUserStore } from '../../../../stores/user'
  import MyPageInterestedCorpJobNoticeListView from './MyPageInterestedCorpJobNoticeListView.vue'
  import mypageJobFairService from '../../../../services/mypage/jobFair/mypageJobFairService'
  import JobFairCorpInfoDetailModal from '../../../../components/modal/jobFair/JobFairCorpInfoDetailModal.vue'

  const route = useRoute()
  const router = useRouter()
  const loadingStore = usePageLoadingStore()
  const { user, isAuthenticated } = useUserStore()
  const globals = getCurrentInstance().appContext.config.globalProperties;
  const { $pageListBoardNo, alert, confirm } = globals;

  const currentPage = ref(1);
  const pageSize = ref(10);
  const totalPages = ref(1);
  const totalCount = ref(0);
  const list = ref([]); // 관심 기업 리스트

  const pageSizeGroup = ref([
    { label:"10개씩 보기", value: 10 },
    { label:"30개씩 보기", value: 30 },
    { label:"50개씩 보기", value: 50 },
    { label:"100개씩 보기", value: 100 },
  ])

  const corpInfoModal = ref(null); // 기업정보

  const isJobNoticeListView = ref(false);
  const selectedCorpId = ref('');

  const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
  }

  // 페이지당 개수 변경
  const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
  }

  const retrieveList = () => {
    const paramObj = {
      pageNumber: currentPage.value || 0,
      size: pageSize.value || 10,
    };

    loadingStore.loading = true;
    mypageJobFairService.retrieveInterestHallEntryCorpListPaging(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      })
      .catch( (res) =>  {
        loadingStore.loading = false;
      });
  }
  // 기업정보 보기
  const onClickCorp = async (corp) => {
    const result = await corpInfoModal.value.show({
      corpId: corp.corpId,
      interestYn: corp.interestYn,
    });
    corp.interestYn = result; // 관심기업여부 업데이트
    retrieveList();
  }

  const onClickJobNoticeCnt = (corpId) => {
    isJobNoticeListView.value = true;
    selectedCorpId.value = corpId;
  }


  // 관심 기업 관심여부 변경
  const onClickCorpEntryYn = async (corp) => {
    const interestYn = corp.interestYn === 'Y' ? 'N' : 'Y';
    const ok = await confirm([`관심기업을 ${interestYn === 'Y' ? '등록' : '삭제'}하시겠습니까?`], `관심기업 ${interestYn === 'Y' ? '등록' : '삭제'}`, "취소");
    if(ok) {
      const paramObj = {
        corpId: corp.corpId,
        interestYn,
      };

      mypageJobFairService.updateInterestHallEntryYn(paramObj)
        .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            await alert([`${interestYn === 'Y' ? '등록' : '삭제'}하였습니다.`]);
            corp.interestYn = interestYn;
            retrieveList(); // 성공 후에만 새로고침
          } else {
            alert([`${interestYn === 'Y' ? '등록' : '삭제'} 실패하였습니다.`]);
          }
        })
        .catch( (res) =>  {
          loadingStore.loading = false;
          alert([`${interestYn === 'Y' ? '등록' : '삭제'} 실패하였습니다.`]);
        });
    }
  }

  // 채용공고 목록
  const ojfJobNoticeList = (corpId) => {
    let paramObj = {
      ojfId: jobDetail.value.ojfId,
      corpId: corpId,
      pageNumber: currentPageDepth2.value || 0,
      size: pageSize.value || 10,
    }
    // loadingStore.loading = true;
    jobFairUserService.ojfJobNoticeList(paramObj)
        .then( (res) => {
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            totalPagesDepth2.value = result.totalPages;
            totalCountDepth2.value = result.totalElements;
            jobNoticeList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
          }
        }).catch( (error) =>  {
      console.log(error);
      loadingStore.loading = false;
    });
  }

  onMounted(() => {
    retrieveList();
  })
</script>

<template>
 <div class="table-form" v-show="!isJobNoticeListView">
    <div class="list-top">
      <p>총 <span>{{ $number(totalCount)}}</span>개</p>
      <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
    </div>
    <div class="table-form">
      <table class="table-form board-mobile-vertical">
        <tr>
          <th>번호</th>
          <th>기업명</th>
          <th>기업형태</th>
          <th>산업군</th>
          <th>업종</th>
          <th>채용공고</th>
          <th>관심 등록일</th>
          <th>관심 삭제</th>
        </tr>
        <tr v-for="corp in list">
          <td>{{ corp.boardNo }}</td>
          <td class="clickable text-overflow long-overflow" @click="onClickCorp(corp)">{{ corp.corpName }}</td>
          <td>{{ $gbNameKR('CORP_GB', corp.corpGb) }}</td>
          <td>{{ $gbNameKR('INDUSTRY_GB', corp.industryGb) }}</td>
          <td class="text-overflow long-overflow">{{ corp.bizType }}</td>
          <td @click="onClickJobNoticeCnt(corp.corpId)" class="clickable">
            {{ corp.jobNoticeCnt }}
          </td>
          <td>{{ $yyyymmddHHmmss(corp.modifyDate) }}</td>
          <td>
            <KSATextButton :text="corp.interestYn !== 'N' ? '♥' : '♡'" @click="onClickCorpEntryYn(corp)" class="red_button" />
          </td>
        </tr>
      </table>
    </div>
    <div class="result-none lecture-none" v-if="list.length === 0">
      등록된 관심기업이 없습니다.
    </div>
    <Paginate
        v-if="list.length > 0"
        v-model="currentPage"
        :page-count="totalPages"
        :click-handler="onSelectPage"
    />
  </div>
  <div v-show="isJobNoticeListView">
    <MyPageInterestedCorpJobNoticeListView
      :corpId="selectedCorpId"
      @go-back="isJobNoticeListView = false"
    />
  </div>
  <JobFairCorpInfoDetailModal ref="corpInfoModal"/> <!-- 기업정보 보기 -->
</template>

<style lang="scss"  scoped>
</style>
